import React from "react";
import { Route } from "react-router-dom";

function RedirectToLogin({ url }) {
  return <Route render={() => window.location.assign(url)} />;
}

export default RedirectToLogin;
